import { ResourceStatusEnum, VersionConfig } from '@/types/schema';

export const DEFAULT_VERSION_CONFIGS = [
  { rootBlockId: ResourceStatusEnum.Draft, status: ResourceStatusEnum.Draft },
  { rootBlockId: ResourceStatusEnum.Published, status: ResourceStatusEnum.Published },
] as VersionConfig[];

export const PREVIEW_STATUS_KEY = 'status';
